export enum FIELD_NAMES {
    VALUE = 'value',
    VALIDITY_START = 'validityStart',
    VALIDITY_END = 'validityEnd',
}

export const DEFAULT_VALUES: FormValues = {
    [FIELD_NAMES.VALUE]: '',
    [FIELD_NAMES.VALIDITY_START]: '',
    [FIELD_NAMES.VALIDITY_END]: '',
};

export interface FormValues {
    [FIELD_NAMES.VALUE]: string;
    [FIELD_NAMES.VALIDITY_START]?: string;
    [FIELD_NAMES.VALIDITY_END]?: string;
}
